import { connect } from 'react-redux';
import DateRangePicker from '../../components/DateRangePicker';
import { getDateFrom, getDateTo, getProjectZoneId } from '../../reducers/analyticsApp';
import changeRange from '../../actions/dateRange';

const mapStateToProps = (state) => ({
  zoneId: getProjectZoneId(state),
  from: getDateFrom(state),
  to: getDateTo(state),
});

export default connect(mapStateToProps, { onChangeRange: changeRange })(DateRangePicker);
